(() => {
  function setup(root = document) {
    root.querySelectorAll('[data-mj-story]').forEach(article => {
      if (article.dataset.mjReady) return;
      article.dataset.mjReady = 'true';
      article.querySelectorAll('[data-mj-close]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          const panel = button.closest('details');
          panel.open = false;
          panel.querySelector('summary').focus({ preventScroll: true });
          panel.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        });
      });
      article.querySelectorAll('.mj-margin-art [tabindex], .mj-notes [tabindex]').forEach(node => node.removeAttribute('tabindex'));
      const openHash = () => {
        const id = location.hash.slice(1);
        const panel = id && document.getElementById(id);
        if (panel?.matches('.mj-panel') && article.contains(panel)) panel.open = true;
      };
      openHash();
      window.addEventListener('hashchange', openHash);
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
